import React from "react";
import {
  bookingTimeZoneLabel,
  formatTripDateLabel,
  formatTripDurationLabel,
  formatTripTimeLabel,
} from "../lib/dateLocal";

function authoritativeDurationLabel(days) {
  if (!Number.isSafeInteger(days) || days <= 0) return "";
  return days === 1 ? "1 day" : `${days} days`;
}

export function bookingDurationLabel(days, startDate, endDate) {
  if (days == null) return formatTripDurationLabel(startDate, endDate);
  return authoritativeDurationLabel(days);
}

export default function BookingScheduleSummary({ booking, testId }) {
  const startDate = booking?.start_date;
  const endDate = booking?.end_date;
  const durationLabel = bookingDurationLabel(booking?.days, startDate, endDate);
  const timezoneLabel = bookingTimeZoneLabel(booking);

  return (
    <section
      className="mt-6 max-w-sm w-full min-w-0 mx-auto text-left text-sm"
      data-testid={testId}
      aria-label="Trip schedule"
    >
      <div className="grid grid-cols-2 gap-x-4 gap-y-3">
        <div className="min-w-0">
          <div className="eyebrow mb-1">Pick-up</div>
          <div className="font-semibold text-[var(--zc-text)] break-words">
            {formatTripDateLabel(startDate)}
          </div>
          <div className="text-[var(--zc-text-2)] mt-0.5 break-words">
            {formatTripTimeLabel(startDate)}
          </div>
        </div>
        <div className="min-w-0 text-right">
          <div className="eyebrow mb-1">Return</div>
          <div className="font-semibold text-[var(--zc-text)] break-words">
            {formatTripDateLabel(endDate)}
          </div>
          <div className="text-[var(--zc-text-2)] mt-0.5 break-words">
            {formatTripTimeLabel(endDate)}
          </div>
        </div>
        {durationLabel && (
          <div
            className="col-span-2 w-full text-center whitespace-nowrap text-xs text-[var(--zc-text-3)]"
            data-testid={testId ? `${testId}-duration` : undefined}
          >
            {durationLabel}
          </div>
        )}
        {timezoneLabel && (
          <div
            className="col-span-2 w-full text-center text-xs text-[var(--zc-text-2)]"
            data-testid={testId ? `${testId}-timezone` : undefined}
          >
            Times shown in {timezoneLabel}
          </div>
        )}
      </div>
    </section>
  );
}
